export const quotaToNumber = (value) => {
    if (value === "00" || value === "0" || value === 0) return 0;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
};

export const filterInstallmentOptions = (options, maxInstallment) => {
    if (maxInstallment === null || maxInstallment === undefined) return options;
    const max = Number(maxInstallment);
    if (Number.isNaN(max)) return options;
    return options.filter((option) => quotaToNumber(option.value) <= max);
};

export const isQuotaAllowed = (quota, maxInstallment) => {
    if (maxInstallment === null || maxInstallment === undefined) return true;
    const max = Number(maxInstallment);
    if (Number.isNaN(max)) return true;
    return quotaToNumber(quota) <= max;
};

export const getPolicyNotice = (policy) => {
    if (!policy || !policy.policy_configured) return "";
    const issuer = policy.issuer || "해당 카드";
    if (!policy.usable || policy.blocked) {
        return policy.issuer ? `${issuer}는 사용할 수 없습니다.` : (policy.message || `${issuer}는 사용할 수 없습니다.`);
    }
    if (policy.max_installment === 0) return `${issuer} · 일시불만 가능`;
    if (policy.max_installment > 0) return `${issuer} · 최대 ${policy.max_installment}개월까지 가능`;
    return `${issuer} · 제한 없음`;
};

export const makePolicyFromMerchantPolicy = (issuer, merchantPolicy) => {
    if (!issuer || !merchantPolicy) return null;
    const blocked = merchantPolicy.blocked_yn === "Y";
    return {
        issuer,
        usable: !blocked,
        blocked,
        max_installment: blocked ? null : merchantPolicy.max_installment,
        policy_configured: true,
        message: blocked ? `${issuer}는 사용할 수 없습니다.` : null,
    };
};

export const buildPolicyMap = (policies = []) => {
    const map = {};
    policies.forEach((policy) => {
        if (!policy?.issuer) return;
        map[policy.issuer] = policy;
    });
    return map;
};
